<template>
  <div class="container-fluid mt-4 SlimTDs">
    <b-row class="mb-3">
      <b-col>
        <span :class="`size-${ButtonSize}`">Muhasebe</span>
      </b-col>

      <b-col cols="auto" class="text-right top-buttons">
        <b-btn class="m-1" type="button" variant="danger" to="/" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1" v-if="ScreenWidth >= 500">Ana Ekran</span>
        </b-btn>

        <b-btn
          href="#"
          @click.prevent="() => { FetchBalances(); return false; }"
          class="btn btn-info m-1"
          :size="ButtonSize"
        >
          <i class="material-icons mifix">refresh</i>
          <span class="ml-1" v-if="ScreenWidth >= 500">Yenile</span>
        </b-btn>

        <b-btn to="/Balance/Add/Earn" class="btn btn-success m-1" :size="ButtonSize">
          <i class="material-icons mifix">add</i>
          <span class="ml-1" v-if="ScreenWidth >= 390">Gelir</span>
        </b-btn>

        <b-btn to="/Balance/Add/Loss" class="btn btn-danger m-1" :size="ButtonSize">
          <i class="material-icons mifix">remove</i>
          <span class="ml-1" v-if="ScreenWidth >= 430">Gider</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-table
      striped
      hover
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :items="Balances"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      responsive
    >
      <template v-slot:cell(Amount)="data">
        <a
          href="#"
          @click.prevent="() => false"
          :class="`btn mr-2 btn-sm btn-${data.item.Amount < 0 ? 'danger' : 'success'} btn-rounded`"
        >
          <i :class="`fa fa-${data.item.Amount < 0 ? 'minus' : 'plus'}`"></i>
          {{ data.item.AmountMoney }}
        </a>
      </template>

      <template v-slot:cell(Date)="data">
        <div class="ws-nowrap">{{ data.item.Date }}</div>
      </template>

      <template v-slot:cell(User)="data">
        <div class="ws-nowrap">{{ data.item.User }}</div>
      </template>

      <template v-slot:cell(Description)="data">
        <div class="ws-nowrap">{{ data.item.Description }}</div>
      </template>
    </b-table>

    <b-row>
      <b-col cols="12" md="4" class="mx-auto my-4">
        <b-pagination
          v-model="currentPage"
          :total-rows="Object.keys(Balances).length"
          :per-page="perPage"
          align="fill"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Services from "../Service";
import datetr from "@/Date";

export default {
  data() {
    return {
      Enums: {
        UserStatus: {
          0: "Pasif",
          1: "Aktif",
          2: "Onay Bekliyor"
        }
      },
      sortBy: "Time",
      sortDesc: true,
      currentPage: 1,
      perPage: 15,
      fields: [
        { key: "User", label: "Kullanıcı", sortable: true },
        { key: "Date", label: "Tarih", sortable: true },
        { key: "Description", label: "Açıklama", sortable: true },
        { key: "Amount", label: "Miktar", sortable: true }
      ],
      Balances: []
    };
  },
  async created() {
    this.FetchBalances();
  },
  computed: {
    ...mapState(["ScreenWidth", "ButtonSize"])
  },
  methods: {
    date: (timestamp, format = "dd.mm.yyyy") => {
      return datetr(timestamp, format);
    },
    async FetchBalances() {
      this.$store.dispatch("AddLoading", "FetchBalances");

      await Services.Nozich.Send("Balances", {}, Data => {
        this.$store.dispatch("RemoveLoading", "FetchBalances");

        if (Data.Status === "Success") {
          let _Balances = [];

          for (let i in Data.Balances) {
            let _Balance = Data.Balances[i];

            _Balances.push({
              Date: this.date(_Balance.Time, "dd.mm.yyyy - HH:MM"),
              Time: _Balance.Time,
              User: _Balance.UserName,
              Description: _Balance.Name !== "" ? _Balance.Name : "---",
              Amount: _Balance.Amount,
              AmountMoney: _Balance.Amount
                ? _Balance.Amount.Money()
                : "0".Money()
            });
          }

          for (let i in Data.Payments) {
            let _Balance = Data.Payments[i];

            if (_Balance.Amount !== null) {
              _Balances.push({
                Date: this.date(new Date(), "dd.mm.yyyy - HH:MM"),
                Time: this.date(new Date(), "yyyymmddHHMMssl"),
                User: "Sistem",
                Description: "Bugünkü Hesaplar Toplamı",
                Amount: _Balance.Amount,
                AmountMoney: _Balance.Amount.Money()
              });
            }
          }

          this.$set(this, "Balances", _Balances);
        }
      });
    }
  },
  mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
